import { authRoleAccess } from "auth/AuthRoleAccess";
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

export const navigationItems = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.dashborad,
  },
  {
    title: 'Committees',
    path: '/committees',
    icon: <GroupsOutlinedIcon />,
    roles: authRoleAccess.committee_setup,
  },
  {
    title: 'Codex Texts',
    path: '/documents',
    icon: <ArticleOutlinedIcon />,
    roles: authRoleAccess.document_view,
  },

  {
    title: 'National Position',
    path: '/setup/national-position-documents',
    icon: <ReceiptLongOutlinedIcon />,
    roles: authRoleAccess.national_position_documents_setup,
  },
  {
    title: 'Collaboration',
    path: '/collaboration',
    icon: <ForumOutlinedIcon />,
    roles: authRoleAccess.collaboration_view,
  },
  {
    title: 'Reports',
    path: '/reports',
    icon: <AssessmentOutlinedIcon />,
    roles: authRoleAccess.reports_view,
  },
  {
    title: 'Audits',
    path: '/audits',
    icon: <FactCheckOutlinedIcon />,
    roles: authRoleAccess.audit_view,
  },
  {
    title: 'Data Setup',
    icon: <StorageOutlinedIcon />,
    //roles: authRoleAccess.dataSetup,
    submenu: [
      {
        title: 'Designations',
        path: '/setup/designations',
        icon: <BadgeOutlinedIcon />,
        roles: authRoleAccess.designations_setup,
      },
      {
        title: 'Roles',
        path: '/setup/roles',
        icon: <AdminPanelSettingsOutlinedIcon />,
        roles: authRoleAccess.roles_setup,
      },
      {
        title: 'Membership Types',
        path: '/setup/membership-types',
        icon: <CardMembershipOutlinedIcon />,
        roles: authRoleAccess.membership_types_setup,
      },
      {
        title: 'Committee Types',
        path: '/setup/committee-types',
        icon: <AccountTreeOutlinedIcon />,
        roles: authRoleAccess.committee_types_setup,
      },
      {
        title: 'Comment Categories',
        path: '/setup/comment-categories',
        icon: <AccountTreeOutlinedIcon />,
        roles: authRoleAccess.comment_categories_setup,
      },
      {
        title: 'Technical Expertise',
        path: '/setup/technical-expertise',
        icon: <AccountTreeOutlinedIcon />,
        roles: authRoleAccess.technical_expertise_setup,
      },
      {
        title: 'Document Types',
        path: '/setup/document-types',
        icon: <AccountTreeOutlinedIcon />,
        roles: authRoleAccess.document_types_setup,
      },
      {
        title: 'Users',
        path: '/setup/users',
        icon: <PersonOutlineOutlinedIcon />,
        roles: authRoleAccess.users_setup,
      },
      {
        title: 'Workflow Setup',
        path: '/setup/workflows',
        icon: <AccountTreeOutlinedIcon />,
        roles: authRoleAccess.workflow_setup,
      }
    ],
  }

  /*   {
      title: 'Incidents',
      icon: <WarningAmberOutlinedIcon />,
      submenu: [
        {
          title: 'Incidents',
          path: '/incidents',
          roles: authRoleAccess.all_incidents_view,
        },
        {
          title: 'Create Incident',
          path: '/create_incidents',
          roles: authRoleAccess.all_incidents_view,
        }
      ],
  
    }, */

  /* {
    title: 'Documentation',
    path: '/themes/examples',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.themeExamples,
  }, */

];
